import {
  AnimatePresence,
  useMotionValue,
  useSpring,
  motion,
  useTransform,
} from "framer-motion";
import React, { useState } from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomTooltip = ({ message, children, leftAlign = false }) => {
  // const tooltip = <Tooltip id="tooltip">{message}</Tooltip>;

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const springConfig = { stiffness: 100, damping: 5 };
  const x = useMotionValue(0); // going to set this value on mouse move
  // rotate the tooltip
  const rotate = useSpring(
    useTransform(x, [-100, 100], [-45, 45]),
    springConfig
  );
  // translate the tooltip
  const translateX = useSpring(
    useTransform(x, [-100, 100], [-50, 50]),
    springConfig
  );

  return (
    // <OverlayTrigger
    //   placement="bottom-end"
    //   delay={{ show: 500, hide: 200 }}
    //   overlay={tooltip}
    //   // trigger={["hover"]}
    // >
    //   <div className="cursor-pointer">{children}</div>
    // </OverlayTrigger>
    <>
      <div
        className="relative group hover:cursor-pointer"
        key={message}
        onMouseEnter={() => setHoveredIndex(message)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <AnimatePresence>
          {hoveredIndex === message && (
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.6 }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1,
                transition: {
                  type: "spring",
                  stiffness: 260,
                  damping: 10,
                },
              }}
              exit={{ opacity: 0, y: 20, scale: 0.6 }}
              style={{
                translateX: translateX,
                rotate: rotate,
                whiteSpace: "nowrap",
              }}
              className={`absolute -top-10 flex text-xs flex-col items-center justify-center rounded-md dark:bg-white bg-black z-[90] shadow-xl px-4 py-2 ${
                leftAlign ? "left-0" : " right-0 "
              }`}
            >
              <div className="dark:text-black text-white text-xs">
                {message}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        {children}
      </div>
    </>
  );
};

export default CustomTooltip;
